// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".-DHFF{--horizonPadding:48px;--horizonPadding:3rem;--closableHeaderPaddingBottom:0;--closableHeaderBorderBottom:none;text-align:center;width:548px;width:34.25rem;border-radius:.25rem}@media(max-width:767px){.-DHFF{width:auto}}.-DHFF ._1r7C_{margin-bottom:1rem;font-size:32px;font-weight:500;line-height:40px;font-family:var(--heading-font);letter-spacing:.5px}@media(max-width:767px){.-DHFF ._1r7C_{font-size:26px;line-height:32.5px}}._3hCdb{display:block;margin:0 auto 1rem}.KC8GU{margin-bottom:.5rem;font-size:18px;line-height:29px}.KC8GU,.qxIkO{color:#595757;font-weight:300;font-family:var(--base-font)}.qxIkO{display:inline-block;font-size:12px;line-height:20px}@media(max-width:767px){.qxIkO{font-size:14px;line-height:23px}}._1fj_T{display:block;text-align:center;margin-top:.5rem;min-height:24px;min-height:1.5rem}._3bAL7{padding-top:.5rem}", ""]);
// Exports
exports.locals = {
	"NAVBAR_HEIGHT": "72",
	"TABLET_WIDTH": "768",
	"DESKTOP_WIDTH": "1024",
	"WIDE_DESKTOP_WIDTH": "1440",
	"root": "-DHFF",
	"title": "_1r7C_",
	"logo": "_3hCdb",
	"description": "KC8GU",
	"notice": "qxIkO",
	"hint": "_1fj_T",
	"ctaButton": "_3bAL7"
};
module.exports = exports;
